import { zodResolver } from "@hookform/resolvers/zod";
import { useForm } from "react-hook-form";
import {
  getRequiredFields,
  removeEmptyFields,
  setEmptyFieldsToNull,
} from "@/lib/utils";
import {} from "../consts";
import { useIsMobile } from "@/hooks/use-mobile";
import { formValues, schema } from "./validations";
import { useEffect } from "react";
import { YEAR_OF_COLLABORATION, GEO_REGION_ID, SCHOOL_NAME, SCHOOL_TIER, ACCOUNT_TYPE, STATE, CITY,
  SKU, NO_OF_FACULTY_DAYS, NO_OF_WORK_STATIONS
 } from "../consts";

// useFilter.tsx - COMPLETE FIXED VERSION
const useFilter = ({
  filterData,
  setFilterData,
  onCancel,
  onApply,
}: {
  filterData: any;
  setFilterData: React.Dispatch<React.SetStateAction<any>>;
  onCancel: () => void;
  onApply?: (filterData: any) => void;
}) => {
  const isMobile = useIsMobile();

  const form = useForm<formValues>({
    resolver: zodResolver(schema),
    defaultValues: {
      [YEAR_OF_COLLABORATION]: "",
      [GEO_REGION_ID]: "",
      [SCHOOL_NAME]: "",
      [ACCOUNT_TYPE]: "",
      [SCHOOL_TIER]: "",
      [STATE]: "",
      [CITY]: "",
      [SKU]: "",
      [NO_OF_WORK_STATIONS]: "",
      [NO_OF_FACULTY_DAYS]: "",
    },
  });

  useEffect(() => {
    if (filterData) {
      const formData = { ...filterData };
      Object.keys(formData).forEach(key => {
        if (formData[key] === null || formData[key] === "null") {
          formData[key] = "";
        }
      });
      form.reset(formData);
    } else {
      form.reset({
        [YEAR_OF_COLLABORATION]: "",
        [GEO_REGION_ID]: "",
        [SCHOOL_NAME]: "",
        [ACCOUNT_TYPE]: "",
        [SCHOOL_TIER]: "",
        [STATE]: "",
        [CITY]: "",
        [SKU]: "",
        [NO_OF_WORK_STATIONS]: "",
        [NO_OF_FACULTY_DAYS]: "",
      });
    }
  }, [filterData, form]);

  const requiredFields = getRequiredFields(schema);

  const onSubmit = (data: formValues) => {
    let _data = removeEmptyFields(data);
    _data = setEmptyFieldsToNull(_data);
    setFilterData(_data);
    if (onApply) {
      onApply(_data);
    }
    onCancel();
  };

  const onClear = () => {
    setFilterData(null);
    form.reset({
      [YEAR_OF_COLLABORATION]: "",
      [GEO_REGION_ID]: "",
      [SCHOOL_NAME]: "",
      [ACCOUNT_TYPE]: "",
      [SCHOOL_TIER]: "",
      [STATE]: "",
      [CITY]: "",
      [SKU]: "",
      [NO_OF_WORK_STATIONS]: "",
      [NO_OF_FACULTY_DAYS]: "",
    });
    
  };

  return {
    form,
    onSubmit,
    requiredFields,
    isMobile,
    onClear,
  };
};

export default useFilter;
